import { render, staticRenderFns } from "./NavigationHeaderSelectionInfo.vue?vue&type=template&id=4572163e&scoped=true&"
import script from "./NavigationHeaderSelectionInfo.vue?vue&type=script&lang=js&"
export * from "./NavigationHeaderSelectionInfo.vue?vue&type=script&lang=js&"
import style0 from "./NavigationHeaderSelectionInfo.vue?vue&type=style&index=0&id=4572163e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4572163e",
  null
  
)

export default component.exports